import { render, staticRenderFns } from "./CopyToCollection.vue?vue&type=template&id=1fdcc942&scoped=true&"
import script from "./CopyToCollection.vue?vue&type=script&lang=js&"
export * from "./CopyToCollection.vue?vue&type=script&lang=js&"
import style0 from "./CopyToCollection.vue?vue&type=style&index=0&id=1fdcc942&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdcc942",
  null
  
)

export default component.exports